import { render, staticRenderFns } from "./Tryfree.vue?vue&type=template&id=2f207ecc&"
import script from "./Tryfree.vue?vue&type=script&lang=js&"
export * from "./Tryfree.vue?vue&type=script&lang=js&"
import style0 from "./Tryfree.vue?vue&type=style&index=0&id=2f207ecc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports